import { BIBCITE_CONTRIBUTORS_MAX_LENGTH } from '../config/constants';

export const formatContributors = (names: string[] = []) => {
  if (names.length === 0) {
    return '';
  }

  if (names.length > BIBCITE_CONTRIBUTORS_MAX_LENGTH) {
    return `${names.slice(0, BIBCITE_CONTRIBUTORS_MAX_LENGTH).join(', ')}, et al`;
  }

  return names.join(', ');
};

export const formatBibciteMetadata = (
  contributors: string[] = [],
  secondaryTitle: string = '',
  publisher: string = '',
  publicationYear?: number,
  volume?: number,
  issue?: number,
  pages?: string,
) => {
  const formattedContributors = formatContributors(contributors);
  const formattedBasicInfo = [formattedContributors, secondaryTitle, publisher].join('. ');
  const formattedPublicationYear = `${publicationYear || 'n.d.'};`;
  const formattedPublicationData = (volume && issue && pages) ? `${volume} (${issue}) : ${pages}.` : '';

  return [formattedBasicInfo, formattedPublicationYear, formattedPublicationData].filter((item) => item.length > 0).join(' ');
};

export const formatOnlineCourseSubtitle = (
  contributors: string[] = [],
  publisher: string = '',
  timestampDeveloped?: number,
  languages?: string[],
) => {
  const formattedContributors = formatContributors(contributors);
  // We need to multiply the timestamp we have to create a valid date object.
  const yearDeveloped = timestampDeveloped ? new Date(timestampDeveloped * 1000).getFullYear().toString() : '';
  const formattedLanguages = languages ? languages.join(', ') : '';

  return [formattedContributors, publisher, yearDeveloped, formattedLanguages].filter((item) => item.length > 0).join(', ');
};

export const formatEventSubtitle = (contributors: string[] = [], locations: string[] = []) => {
  const formattedContributors = formatContributors(contributors);
  const dot = formattedContributors && locations.length > 0 ? '<div class="dot">.</div>' : '';

  return `${formattedContributors}${dot}${locations.join(', ')}`;
};
